// extracted by mini-css-extract-plugin
module.exports = {"form":"form-view_form__3JvYB","input":"form-view_input__3_7Qw"};